<!-- Tab图文信息展示列表：模块头+Tab按钮+图片+标题+内容 -->
<template>
<div class="content-block" >
  <div class="info-list-search">
    <div class="list-search-div">
      <input type="text" name="site-search" class="search-input" v-model="keyword" placeholder="输入关键字搜索"/><a @click="searchAct()" class="search-button">搜索</a>
    </div>
<!--    <div>-->
<!--      <ul class="list-tab-ul" v-if="tabList.length>0">-->
<!--        <li v-for="(tab, index) in tabList" v-bind:class="['list-tab-li',tab.type==selectTab ?'li-active' : '']" v-on:click="selectedAct(tab.type)">{{tab.title}}</li>-->
<!--      </ul>-->
<!--    </div>-->
  </div>
  <div class="info-list-content" v-if="infoPage&&infoPage.list">
    <div class="list-container" v-if="infoPage.list.length>0">
      <div class="list-container-cell" v-for="info in infoPage.list" :style="{'width': celWidth}">
        <component :is="infoBlock" :info="info"/></component>
      </div>
    </div>
    <div class="no-record-1" v-if="infoPage.list.length<1"></div>
    <pagination :page="infoPage"  v-on:queryData="queryPage"/>
  </div>
</div>
</template>

<script>
import Pagination from '../utils/Pagination'
export default {
  name: 'SearchPageList01',
  components: {'pagination': Pagination},
  props: {
    title: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    col: {
      type: String,
      default: '4'
    },
    count: {
      type: String,
      default: '6'
    },
    infoBlock: {
      type: Object,
      default: {}
    },
    tabList: {
      type: Array,
      default: []
    },
    tabDefaultType: {
      type: String,
      default: '1'
    },
    infoPage: {
      type: Object,
      default: function () { return {list: [], total: 0} }
    }
  },
  data () {
    return {
      keyword: '',
      selectTab: this.tabDefaultType,
      celWidth: 'calc(100%/' + this.col + ')',
      params: {page: 1, pageSize: this.count, type: this.tabDefaultType, total: 0, keyword: ''}
    }
  },
  methods: {
    selectedAct: function (type) {
      this.selectTab = type
      this.params.type = type
      this.params.page = 1
      this.params.total = 0
      this.$emit('queryPage', this.params)
    },
    searchAct: function () {
      this.params.keyword = this.keyword
      this.params.page = 1
      this.params.total = 0
      this.$emit('queryPage', this.params)
    },
    queryPage: function (params) {
      // console.log("查询分页数据："+JSON.stringify(params));
      this.params = params
      this.$emit('queryPage', this.params)
    }
  },
  created: function () {
    this.queryPage(this.params)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.info-list-search{
  width:100%;
  height:180px;
  //background:red;
}
.list-search-div{
  position:relative;
  margin:0px auto;
  padding-top:30px;
  width:500px;
  height:100px;
  //background:green;
  text-align:center;
}

.list-search-div .search-input {
  display: block;
  float: left;
  width: 400px;
  height: 40px;
  outline-style: none;
  border: 2px solid var(--color6);
  font-size: 14px;
  padding-left: 5px;
  background:#eee;
}

.list-search-div .search-button {
  display: block;
  float: left;
  width: 100px;
  height: 40px;
  text-decoration: none;
  background: var(--color6);
  font-size: 12px;
  color:#ffffff;
  text-align: center;
  line-height: 40px;
  letter-spacing:5px;
}

.search-button:hover{
  cursor: pointer;
}

.list-tab-ul {
  display:flex;
  justify-content:space-between;
  margin: 0 auto;
  width:500px;
  height:80px;
  text-align:center;
  list-style-type: none;
  padding-top: 15px;
  //background:yellow;
}

.list-tab-li {
  float: left;
  margin: 0px 10px 0px 10px;
  height: 30px;
  width: 100px;
  color: #000000;
  font-size: 12px;
  line-height: 30px;
  text-align: center;
  border:1px solid #fff;
  background: #598118-#BE550F;
}

.list-tab-li:hover{
  cursor: pointer;
  border:1px solid #888;
}

.li-active{
  color: #ffffff;
  background: #598118;
  border:1px solid #598118;
  background: -moz-linear-gradient(left,  #598118 50%, #BE550F 100%);
  background: -webkit-gradient(linear, left top, left bottom, color-stop(50%,#BE550F), color-stop(100%,#BE550F));
  background: -webkit-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: -o-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: -ms-linear-gradient(left,  #598118 f0%,#BE550F 100%);
  background: linear-gradient(to right,  #598118 f0%,#BE550F 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#598118', endColorstr='#BE550F',GradientType=0 );
}

.list-container {
  display: flex;
  flex-wrap: wrap;
}

.list-container-cell {
  box-sizing: border-box;
  height: 100%;
  background: #fff;
  border: 0px solid red;
  //background:red;
}

</style>



// WEBPACK FOOTER //
// src/components/block/SearchPageList01.vue